import React from 'react'
import PropTypes from 'prop-types'

import { zipObject, keyBy } from 'lodash'
import { timeFormat } from 'd3-time-format'
import Amount from 'components/Amount'
import { get, every } from 'lodash'
import fitWidth from 'utils/fitWidth'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import { withTheme } from 'material-ui/styles'
import compose from 'recompose/compose'
import { CurrenciesIcon } from 'assets/currencies'
import { AreaChart, Area, XAxis, YAxis, Tooltip } from 'recharts'
const dateFormat = timeFormat('%d/%m')
const shortDateFormat = timeFormat('%d/%m')

class HistoryAreaChart extends React.Component {
  state = {
    selectedCurrency: null,
  }

  renderTooltip = ({ active, label, type, payload, ...others }) => {
    if (active) {
      const total = Object.values(payload[0].payload).reduce(
        (sum, val) => sum + get(val, 'value', 0),
        0
      )
      return (
        <div>
          {this.state.selectedCurrency && (
            <div style={{ paddingBottom: 20 }}>
              <div style={{ display: 'flex' }}>
                <CurrenciesIcon currency={this.state.selectedCurrency} />
                <div style={{ alignSelf: 'center', paddingLeft: 5 }}>
                  {this.state.selectedCurrency}
                </div>
              </div>
              <Amount
                value={
                  payload[0].payload[this.state.selectedCurrency] &&
                  payload[0].payload[this.state.selectedCurrency].value
                }
                mainCurrency
              />
            </div>
          )}
          <div style={{ fontSize: 24 }}>
            <Amount value={total} mainCurrency />
          </div>
          <div>{dateFormat(label)}</div>
        </div>
      )
    }
    return null
  }

  onMouseEnterArea = currency => {
    this.setState({ selectedCurrency: currency })
  }

  getData = currencies => {
    const { funds, history, mainCurrency, fiat } = this.props
    const fundsByCrypto = keyBy(funds, 'currency')
    const shouldUseFundHistory = every(currencies, f => f === 'ETH')
    return history.map(({ timestamp, ...cHistory }) => ({
      timestamp,
      ...zipObject(
        currencies,
        currencies
          // compute the balance
          .map((currency, i) => {
            const fund = fundsByCrypto[currency]
            if (!shouldUseFundHistory || get(fund, 'history', []).length < 1) {
              return {
                balance: fund.balance,
              }
            }
            // get balance at ts
            return {
              balance: fund.history
                .filter(h => h.timestamp < timestamp)
                .reduce((sum, v) => {
                  if (v.to === 'me') {
                    return sum + v.value
                  } else if (v.from === 'me') {
                    return sum - v.value
                  }
                  return sum
                }, 0),
            }
          })
          // compute the value
          .map(({ balance }, i) => {
            const valueUSD = balance * (cHistory[currencies[i]] || 0)
            return {
              balance,
              // convert in main currency value
              value: valueUSD / fiat.USD.value * fiat[mainCurrency].value,
            }
          })
      ),
    }))
  }

  render() {
    const {
      theme,
      colors,
      funds,
      highlightedCurrencies,
      height,
      width,
    } = this.props
    const currencies = funds
      .map(f => f.currency)
      .filter(
        c =>
          highlightedCurrencies.length === 0 ||
          highlightedCurrencies.indexOf(c) > -1
      )
    const data = this.getData(currencies)
    return (
      <AreaChart
        width={width}
        height={height}
        data={data.slice(-120)}
        style={{
          left: theme.breakpoints.width('md') < width ? 10 : 0,
          position: 'relative',
        }}
      >
        {currencies.map((c, i) => (
          <Area
            key={i}
            onMouseEnter={() => this.onMouseEnterArea(c)}
            animationDuration={750}
            stackId="1"
            type="monotone"
            dataKey={`${c}.value`}
            fillOpacity={0.8}
            stroke={colors(c)}
            fill={colors(c)}
          />
        ))}
        <XAxis
          dataKey="timestamp"
          tickFormatter={tickItem => shortDateFormat(tickItem)}
          stroke={theme.palette.text.primary}
          interval={theme.breakpoints.width('md') > width ? 30 : 14}
          tickSize={12}
          tick={{
            paddingTop: 10,
            fontSize: 12,
          }}
        />
        <YAxis
          stroke={theme.palette.text.primary}
          axisLine={false}
          tickSize={12}
          tick={{
            fontSize: 12,
          }}
        />
        <Tooltip content={this.renderTooltip} />
      </AreaChart>
    )
  }
}

HistoryAreaChart.propTypes = {
  funds: PropTypes.array.isRequired,
  history: PropTypes.array.isRequired,
  colors: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number,
}

HistoryAreaChart.defaultProps = {
  type: 'svg',
  width: 500,
  height: 350,
  ratio: 1,
}

const mapStateToProps = state => ({
  mainCurrency: selectors.mainCurrency(state),
  fiat: selectors.ticker(state).fiat,
  highlightedCurrencies: selectors.highlightedCurrencies(state),
})

export default compose(fitWidth, withTheme(), connect(mapStateToProps))(
  HistoryAreaChart
)



// WEBPACK FOOTER //
// ./src/components/HistoryAreaChart.js